import api from "./API";
export const setOrder = (params) => {
  return api.post(
    "https://www.propay.it.com/index.php/api/Urlorder/setOrder",
    params,
  );
};

export const getOrder = (session_id, signal) => {
  return api.post(
    "https://www.adminv.online/api/Urlorder/get_session_id_order",
    { session_id },
    { signal },
  );
};
